import { FC } from 'react';
import BulkActions from '../BulkActions';
import useBulkActions from '../UserDrawerContent/hooks/useBulkActions';
import { User } from '../../types/User';

interface UserManagementBulkActionsProps {
    onClose: () => void;
    selectedUsers: User[];
}

const UserManagementBulkActions: FC<UserManagementBulkActionsProps> = ({ selectedUsers, onClose }) => {
    const { actions, menuActions } = useBulkActions({ selectedUsers, onClose });

    return (
        <BulkActions
            selectedItems={selectedUsers}
            onClose={onClose}
            actions={actions}
            menuActions={menuActions}
            selectionText={{ singular: 'user', plural: 'users' }}
        />
    );
};

export default UserManagementBulkActions;
